import { NAME as APP_NAME } from 'constants';
import React from 'react';
import * as I18n from 'circe/I18n';
import { colors } from 'assets/theme/const';
import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
import NotificationsActiveIcon from 'mdi-react/NotificationsActiveIcon';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';
import BlockIcon from 'mdi-react/BlockIcon';
import TruckDeliveryIcon from 'mdi-react/TruckDeliveryIcon';
import TruckCheckIcon from 'mdi-react/TruckCheckIcon';

export const NAME = `${APP_NAME}/MANIFEST`;

export const REDUCER_NAME = 'manifest';

export const ENDPOINTS = {
  MANIFEST_DETAILS_BY_CODE: `${SHIPPING_EDGE}/api/manifest/by-manifest-code/:code`,
  CREATE_MW: `${SHIPPING_EDGE}/api/manifest/create-mw`,
  ASSIGN_MW: `${SHIPPING_EDGE}/api/manifest/assign-mw-manifests`,
};

export const ROUTES = {
  ROOT: '/manifest',
};

export const MANIFEST_STATUS = {
  PROPOSED: {
    label: I18n.str('MANIFEST_PROPOSED', 'Proposed'),
    code: 'PROPOSED',
    icon: <NotificationsActiveIcon />,
    color: colors.orange,
  },
  MANIFESTING: {
    label: I18n.str('MANIFEST_MANIFESTING', 'Manifesting'),
    code: 'MANIFESTING',
    icon: <NotificationsActiveIcon />,
    color: colors.orange,
  },
  COMPLETED: {
    label: I18n.str('MANIFEST_COMPLETED', 'Completed'),
    code: 'COMPLETED',
    icon: <CheckCircleIcon />,
    color: colors.green,
  },
  EXCEPTION: {
    label: I18n.str('MANIFEST_EXCEPTION', 'Exception'),
    code: 'EXCEPTION',
    icon: <AlertCircleOutlineIcon />,
    color: colors.red,
  },
  DELETED: {
    label: I18n.str('MANIFEST_DELETED', 'Deleted'),
    code: 'DELETED',
    icon: <BlockIcon />,
    color: colors.red,
  },
  LOADING: {
    label: I18n.str('MANIFEST_LOADING', 'Loading'),
    code: 'LOADING',
    icon: <TruckDeliveryIcon />,
    color: colors.blue,
  },
  UNLOADING: {
    label: I18n.str('MANIFEST_UNLOADING', 'Unloading'),
    code: 'UNLOADING',
    icon: <TruckCheckIcon />,
    color: colors.blue,
  },
  RECEIVED: {
    label: I18n.str('MANIFEST_RECEIVED', 'Received'),
    code: 'RECEIVED',
    icon: <CheckCircleIcon />,
    color: colors.blue,
  },
};
